<template>
    <div class="room-bottom">
        <!-- 当前商品 start -->
        <goods class="goods" @showgoods="showgoods"></goods>
        <!-- 当前商品 end -->
        <!-- 消息输入 start -->
        <message class="message" @send-message="sendMessage" :isTimReady="isTimReady"></message>
        <!-- 消息输入 end -->
        <!-- 送礼物 start -->
        <gift class="gift" @showGift="showGift"></gift>
        <!-- 送礼物 end -->
        <!-- 点赞 start -->
        <like class="like" @like="like"></like>
        <!-- 点赞 end -->
    </div>
</template>

<script>

import goods from './goods'
import gift from './gift'
import like from './like'
import message from './message'
export default {
  props: {
    header: {},
    isTimReady: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  components: {
    goods,
    gift,
    like,
    message
  },
  methods: {
    showgoods () {
      this.$emit('showgoods')
    },
    showGift () {
      this.$emit('showGift')
    },
    sendMessage (data) {
      this.$emit('send-message', data)
    },
    like () {
      this.$emit('like')
    }
  },
  created () {},
  mounted () {}
}
</script>
<style type="scss" scoped>
    .room-bottom{display: flex}
    .goods {
        margin: 0 0.675rem 0 0.675rem;
        display: inline-block;
        vertical-align: middle
    }
    .gift {
        margin: 0 0.84375rem 0 1.4765625rem;
        display: inline-block;
        vertical-align: middle
    }
    .like {
        margin-right: 0.84375rem;
        display: inline-block;
        vertical-align: middle
    }
    .message {
        flex:1;
        /*width: 5.6109375rem;*/
        height: 1.3921875rem;
        display: inline-block;
        background: rgba(0, 0, 0, 0.25);
        border-radius: 0.84375rem;
        border-radius: 0.84375rem;
        vertical-align: middle
    }
</style>
